var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { eager: "", "max-width": "400" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "div",
        { staticClass: "valore-edit" },
        [
          _c("v-card", [
            _c(
              "div",
              { staticClass: "header navy white--text" },
              [
                _vm.context == "calciatore"
                  ? _c("div", { staticClass: "title" }, [
                      _vm._v(
                        "\n          Modifica costo " +
                          _vm._s(_vm.nomeCalciatore) +
                          "\n        "
                      ),
                    ])
                  : _c("div", { staticClass: "title" }, [
                      _vm._v("Modifica crediti " + _vm._s(_vm.nomeSquadra)),
                    ]),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "mr-2 white--text",
                    attrs: { icon: "", small: "" },
                    on: { click: _vm.dismiss },
                  },
                  [_c("v-icon", [_vm._v("close")])],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "body d-flex justify-center align-center ma-5" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "yellow darken-2 white--text ma-2",
                    attrs: { fab: "", depressed: "", "x-small": "" },
                    on: { click: _vm.decrease },
                  },
                  [
                    _c("v-icon", { staticClass: "white--text" }, [
                      _vm._v("remove"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "valore" }, [
                  _vm._v(_vm._s(_vm.valore)),
                ]),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "yellow darken-2 white--text ma-2",
                    attrs: { fab: "", depressed: "", "x-small": "" },
                    on: { click: _vm.increase },
                  },
                  [
                    _c("v-icon", { staticClass: "white--text" }, [
                      _vm._v("add"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "actions" },
              [
                _c("v-divider"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex justify-center" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "navy white--text ma-2",
                        attrs: { rounded: "", depressed: "" },
                        on: { click: _vm.salva },
                      },
                      [_vm._v("Salva")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }